import {
  Component,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Pipe,
  PipeTransform,
  ViewChild,
} from "@angular/core";

import {
  DataService as CoreDataService,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
} from "@barthauer/abc/core/data";

import { DatePipe, formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { AbcCore, ConvertHelper, FileHelper } from "@barthauer/abc/core";
/* import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf'; */
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ExportingEvent } from "devextreme/ui/data_grid";
import { Subscription } from "rxjs";
import {
  NotificationMessage,
  ToastType,
} from "../../models/enumeration-list.model";
import { IExtensionService, IReport } from "../../models/interfaces.model";
import { AppService } from "../../services/app.service";
import { BasedRoleOPathService } from "../../services/based-role-opath.service";
import { DataService, ObjectKeys } from "../../services/data.service";
import { NotificationService } from "../../services/notification.service";
 
import { AbcPopupComponent } from "@barthauer/abc/ui-components";
import { AbcConfigService } from "@barthauer/abc/core/configuration";
import { ReportService } from "./reports.service";
@Component({
  selector: "ubt-geods-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent implements OnInit, OnDestroy {
  @ViewChild('openGenerateReport') openGenerateReport: AbcPopupComponent;
  public allReports: CustomReport[] = [];
  public showAllReports = true;
  public convertHelper = ConvertHelper;
  private reportColumns = new QueryObjectsModel();
  private measures = [];
  private subscriptions: Subscription[] = [];
  public noDataText = this.dataService.res("Ubt-No-Data-text");
  public selectedDate: Date = new Date();
  public maxDate: Date;
  public cellTemplates = [
    "diffCellTemplateProgress",
    "diffCellTemplateNextSteps",
    "diffCellTemplateDecision",
    "diffCellTemplateRiskAndChance",
  ];

  public tabs = [
    {
      id: 0,
      text: this.dataService.res("Ubt-Report-All"),
      icon: "assets/images/Termine.svg",
    },
    {
      id: 1,
      text: this.dataService.res("Ubt-Report-Actual"),
      icon: "assets/images/measure.svg",
      content: "Comment tab content",
    },
  ];

  public readonly exportFileName =
    this.dataService.res("Ubt-TreeList-Reports") +
    "_" +
    this.datePipe.transform(new Date(), "dd.MM.yyyy");
 
  constructor(
    private coreDataService: CoreDataService,
    public dataService: DataService,
    private abcCore: AbcCore,
    public appService: AppService, 
    private router: Router,
    private datePipe: DatePipe,
    private notificationService: NotificationService,
    private configService : AbcConfigService,
    private sanitizer: DomSanitizer,
    private opathService: BasedRoleOPathService,
    private reportService : ReportService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.maxDate = new Date(); 
  }

  public ngOnInit(): void {
    this.appService.showLoader(true);
    this.prepareMeasuresReport();
  }

  public cellPrepared(event) {
    if (
      event.column.dataField === "progress" ||
      event.column.dataField === "nextSteps" ||
      event.column.dataField === "riskAndChance" ||
      event.column.dataField === "decision"
    ) {
      event.cellElement.style.height = 100;
      event.cellElement.style.whiteSpace = "normal";
      event.cellElement.style.overflowWrap = "break-word";
    }
    if (event.rowType === "header") {
      event.cellElement.style.textAlign = "left";
    }
  }

  public openTab = (event): void => {
    switch (event.itemData.id) {
      case 0:
        this.prepareReports(false);
        break;
      case 1:
        this.prepareReports(true);
        break;
    }
  };

  private prepareReports(loadLatestReports: boolean): void {
    this.allReports = [];
    let hasMeasureProgress = false;
    if (!Array.isArray(this.measures) || this.measures.length === 0) {
      this.appService.showLoader(false);
      this.notificationService.callNotification({
        message: NotificationMessage.Empty,
        type: ToastType.INFO,
      });
      return;
    }

    this.measures?.forEach((item) => {
      if (
        Array.isArray(item?.MeasureProgress) &&
        item.MeasureProgress.length > 0
      ) {
        hasMeasureProgress = true;
        if (loadLatestReports === false) {
          item.MeasureProgress.sort(
            (a, b) =>
              new Date(b.ProgressDate).valueOf() -
              new Date(a.ProgressDate).valueOf()
          ).forEach((meausreProgress, index) => {
            const progress: CustomReport = new CustomReport();
            const currentState: ReportStatus = new ReportStatus();
            progress.subProject = item.SubProjectLabel;
            progress.measure = item.Label;
            progress.measureId = item.Id;
            progress.nextSteps = meausreProgress.NextSteps
              ? meausreProgress.NextSteps
              : "";
            progress.progress = meausreProgress.Progress
              ? meausreProgress.Progress
              : "";
            progress.decision = meausreProgress.Decision
              ? meausreProgress.Decision
              : "";
            progress.opportunities = meausreProgress.Opportunities;
            progress.riskAndChance = meausreProgress.RiskAndChance
              ? meausreProgress.RiskAndChance
              : "";
            progress.progressPercentage = meausreProgress.ProgressPercentage;
            progress.maturityLevel = meausreProgress.MaturityLevel;
            progress.date = this.convertHelper.toDate(
              meausreProgress?.ProgressDate.toString()
            );
            currentState.date = formatDate(
              meausreProgress.ProgressDate?.toString(),
              "MM.dd.yyyy",
              this.locale
            ).toString();
            currentState.maturity = meausreProgress.MaturityLevel;
            currentState.progress = meausreProgress.ProgressPercentage;
            currentState.state =
              item.MeasureProgress[index + 1] !== undefined
                ? meausreProgress.ProgressPercentage >=
                  item.MeasureProgress[index + 1].ProgressPercentage
                  ? true
                  : false
                : true;
            progress.status = currentState;
            this.allReports.push(progress);
          });
          this.appService.showLoader(false);
        } else {
          const progress: CustomReport = new CustomReport();
          const currentState: ReportStatus = new ReportStatus();
          progress.subProject = item.SubProjectLabel;
          progress.measure = item.Label;
          progress.measureId = item.Id;
          item.MeasureProgress.sort(
            (a, b) =>
              new Date(b.ProgressDate).valueOf() -
              new Date(a.ProgressDate).valueOf()
          );
          item.MeasureProgress.sort(
            (a, b) =>
              new Date(a.ProgressDate).valueOf() -
              new Date(b.ProgressDate).valueOf()
          );
          progress.nextSteps =
            item.MeasureProgress[item.MeasureProgress.length - 1].NextSteps;
          progress.progress =
            item.MeasureProgress[item.MeasureProgress.length - 1].Progress;
          progress.decision =
            item.MeasureProgress[item.MeasureProgress.length - 1].decision;
          progress.riskAndChance =
            item.MeasureProgress[item.MeasureProgress.length - 1].RiskAndChance;
          progress.opportunities =
            item.MeasureProgress[item.MeasureProgress.length - 1].Opportunities;
          progress.progressPercentage =
            item.MeasureProgress[
              item.MeasureProgress.length - 1
            ]?.ProgressPercentage;
          progress.date = this.convertHelper.toDate(
            item.MeasureProgress[
              item.MeasureProgress.length - 1
            ]?.ProgressDate.toString()
          );
          progress.maturityLevel =
            item.MeasureProgress[item.MeasureProgress.length - 1].MaturityLevel;
          currentState.date =
            item.MeasureProgress[item.MeasureProgress.length - 1].ProgressDate;
          currentState.maturity =
            item.MeasureProgress[item.MeasureProgress.length - 1].MaturityLevel;
          currentState.progress =
            item.MeasureProgress[
              item.MeasureProgress.length - 1
            ].ProgressPercentage;
          currentState.state =
            item.MeasureProgress[item.MeasureProgress.length - 1]
              .ProgressPercentage >=
            item.MeasureProgress[item.MeasureProgress.length - 2]
              ?.ProgressPercentage
              ? true
              : false;
          progress.status = currentState;
          this.allReports.push(progress);
        }
      }
    });
    if (!hasMeasureProgress) {
      this.appService.showLoader(false);
      this.notificationService.callNotification({
        message: NotificationMessage.Empty,
        type: ToastType.INFO,
      });
    }
  }

  public openMeasureDetail = (event): void => {
    this.dataService.appService.showMeasureIcon = true;
    this.router.navigate([
      "measureDetail",
      "reports",
      event.row.data.measureId,
    ]);
  };

  public prepareMeasuresReport(): void {
    const measure: Query = new Query();
    const measureColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn(
        "Id",
        "Id",
        QueryColumnSortOrder.None
      ),
      this.coreDataService.createQueryColumn(
        "Designation",
        "Label",
        QueryColumnSortOrder.None
      ),
      this.coreDataService.createQueryColumn(
        "!.Designation",
        "SubProjectLabel"
      ),
    ];
    measure.ObjectType = ObjectKeys.MEASURE;
    measure.OPath = this.opathService.checkMeasureOPath();
    measure.Columns = measureColumns;
    const measureProgress: Query = new Query();
    measureProgress.Name = "MeasureProgress";
    measureProgress.OPath = "MeasureProgresses";
    const measureProgressColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn("Decision", "Decision"),
      this.coreDataService.createQueryColumn("MaturityLevel", "MaturityLevel"),
      this.coreDataService.createQueryColumn("NextSteps", "NextSteps"),
      this.coreDataService.createQueryColumn("Opportunities", "Oppotunities"),
      this.coreDataService.createQueryColumn("Progress", "Progress"),
      this.coreDataService.createQueryColumn("ProgressDate", "ProgressDate"),
      this.coreDataService.createQueryColumn(
        "Concat(FormatDate(SysDateInsert,'yyyy/MM/dd'),' ',FormatTime(SysTimeInsert,'hh:mm:ss'))",
        "Identifier",
        QueryColumnSortOrder.Descending
      ),
      this.coreDataService.createQueryColumn(
        "ProgressPercentage",
        "ProgressPercentage"
      ),
      this.coreDataService.createQueryColumn("RiskAndChance", "RiskAndChance"),
    ];
    measureProgress.Columns = measureProgressColumns;
    measureProgress.LimitOffset = 0;
    measureProgress.LimitCount = 2;
    measure.ObjectQueries = [measureProgress];
    this.reportColumns.ObjectQueries = [measure];
    this.coreDataService.executeReadObjectsQuery(this.reportColumns).subscribe(
      (data: any) => {
        this.measures = data;
        this.prepareReports(false);
      },
      (error) => {
        console.error(error);
        this.appService.showLoader(false);
      }
    );
  }

     public openPopup(): void {


     }
   public openGenerateReportPopup() {
      this.openGenerateReport.instance.show();
    }
    
  public  closePopup() {
      this.openGenerateReport.instance.hide();
    }

    public async generateReport(selectedDate: Date):  Promise<void> { 
      const utcDate = new Date(selectedDate.getTime() - (selectedDate.getTimezoneOffset() * 60000)); 
      const projectId: string = localStorage.getItem("projectId");
      const reportParameters: IReport = {
        ProjectId: projectId,
        StartingFrom: utcDate.toISOString(),
    }; 
    this.openGenerateReport.instance.hide();
    this.appService.showLoader(true);
    try {
      await this.reportService
        .generateReport(reportParameters)
        .toPromise()
        .then((data) => {
          const reportBase64 = data as unknown as IExtensionService<IReport>;
          const fileName: string = localStorage.getItem("projectName");
          FileHelper.downloadPptxFromBase64(
            reportBase64.Data.FileContent,
            fileName
          );
        });
    } catch (error) {
      this.abcCore.error.publish(error);
    } finally {
        
      this.appService.showLoader(false);
    }

    
    } 

   
 
    /*
  public navigateToLandingPage(selectedDate: Date): void { 
    const utcDate = new Date(selectedDate.getTime() - (selectedDate.getTimezoneOffset() * 60000)); 
    const projectId: string = localStorage.getItem("projectId");
    const reportParameters: IReport = {
      ProjectId: projectId,
      StartingFrom: utcDate.toISOString(),
  };  
  const encodedParams = btoa(JSON.stringify(reportParameters));
  const url = this.configService.getConfiguration().WebApi.BaseURL + `/aims/landing-page?data=${encodedParams}` ;  
    window.open(url, '_blank');
  } 

    */
  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  public onExporting(event: ExportingEvent): void {
    this.dataService.onExporting(event,this.exportFileName);
  }

  public sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Pipe({ name: "gridCellData" })
export class GridCellDataPipe implements PipeTransform {
  transform(gridData: any) {
    return gridData.data["status"];
  }
}

export class CustomReport {
  measureId: string;
  measure: string;
  subProject: string;
  nextSteps: string;
  opportunities: string;
  progress: string;
  decision: string;
  maturityLevel: string;
  progressPercentage: number;
  date: string;
  riskAndChance: string;
  status: ReportStatus;
}

export class ReportStatus {
  date: string | Date;
  progress: number;
  maturity: string;
  state: boolean;
}
